/**
 * RFC 5545 line folding: CRLF followed by a single space or tab is removed
 * so the following line continues the previous one.
 *
 * @param {string} text raw ICS body
 * @returns {string}
 */
export function unfoldIcs(text) {
    if (!text || typeof text !== 'string') {
        return '';
    }
    return text.replace(/\r\n[\t ]/g, '').replace(/\n[\t ]|\r[\t ]/g, '');
}
